module.exports = require('constants');